module.exports = __webpack_public_path__ + "static/img/DanielCherny.6650ea5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DanielCherny.jpg
// module id = 5/I/
// module chunks = 0